/**
 * Deterministic PRNG for game content generation.
 * Same algorithm as practice drills so seeds produce reproducible games.
 */

export function makeRng(seed) {
  let t = seed >>> 0;
  return function rng() {
    t += 0x6D2B79F5;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}

export const GAME_WORDS = Object.freeze([
  'type', 'fast', 'word', 'code', 'game', 'keys', 'line', 'flow', 'pace',
  'jump', 'find', 'hold', 'move', 'read', 'rapid', 'quick', 'skill', 'speed',
  'swift', 'track', 'react', 'focus', 'sharp', 'clear', 'light', 'prime',
  'blaze', 'chase', 'drift', 'fresh', 'glide', 'haste', 'leap', 'match',
  'pace', 'quick', 'race', 'shift', 'tempo', 'urgent', 'vigil', 'whirl',
  'xenon', 'yield', 'zephyr', 'aria', 'bold', 'crisp', 'daring', 'eager',
  'flash', 'grip', 'haste', 'idea', 'jolt', 'knack', 'lively', 'motion',
]);

export function pickWord(rng) {
  return GAME_WORDS[Math.floor(rng() * GAME_WORDS.length)];
}

export const DIFFICULTY_MULTIPLIERS = Object.freeze({
  easy: 1,
  medium: 1.5,
  hard: 2,
});

export const DIFFICULTY_SETTINGS = Object.freeze({
  easy: { spawnIntervalMs: 2200, fallDurationMs: 9000, speedupPer30s: 0.05 },
  medium: { spawnIntervalMs: 1600, fallDurationMs: 7000, speedupPer30s: 0.1 },
  hard: { spawnIntervalMs: 1100, fallDurationMs: 5500, speedupPer30s: 0.15 },
});